import { api } from "@/api/axios.ts";
import {
  ApiApprovalCategory,
  ApiApprovalCategoryPayload,
} from "@/types/approvals/approval-category.type.ts";
import { ApiOperationResult } from "@/types/common.types.ts";

export const approvalCategoryApi = {
  getAll: () => {
    return api.get<ApiApprovalCategory[]>("/api/v1/approval-categories");
  },
  getById: async function (id: number) {
    return api.get<ApiApprovalCategory>(`/api/v1/approval-categories/${id}`);
  },
  create: async function (payload: ApiApprovalCategoryPayload) {
    return api.post<ApiApprovalCategory>("/api/v1/approval-categories", payload);
  },
  update: async function (id: number, payload: ApiApprovalCategoryPayload) {
    return api.put<ApiApprovalCategory>(`/api/v1/approval-categories/${id}`, payload);
  },
  delete: async function (id: number) {
    return api.delete<ApiOperationResult>(`/api/v1/approval-categories/${id}`);
  },
};
